export const DEFAULT_PUBLIC_PERSON_SIMULATOR_PATH = '/simuladorpersonas';
export const DEFAULT_PUBLIC_PERSON_SIMULATOR_MKT_PATH = '/simulador-personas-mkt';
